(function () {
  function ready(fn) {
    document.readyState !== "loading"
      ? fn()
      : document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const root  = document.querySelector("[data-wb-root]");
    if (!root) return;

    const fab   = root.querySelector(".wbubble__fab");
    const panel = root.querySelector("#wbubble-panel");
    const close = root.querySelector(".wbubble__close");
    const scrim = root.querySelector(".wbubble__scrim");
    if (!fab || !panel) return;

    // --- Fallback: compute & set widths if theme JS didn't ---
    function forceProgress() {
      const wrap = panel.querySelector("#cart-progress");
      if (!wrap) return;

      // read numbers from DOM
      const weightText = panel.querySelector("#cp-weight")?.textContent || "";
      const weight = parseFloat(weightText.replace(/[^\d.]/g, "")) || 0;

      const sendleMax = parseFloat(wrap.getAttribute("data-sendle-max") || "0") || 0;
      const ausMax    = parseFloat(wrap.getAttribute("data-auspost-max") || "0") || 0;

      const sendleEl = panel.querySelector("#cp-sendle");
      const ausEl    = panel.querySelector("#cp-auspost");

      // remove any transforms that might hide the fill
      panel.querySelectorAll(".cp-fill").forEach(el => { el.style.transform = "none"; });

      if (sendleEl && sendleMax > 0) {
        const pct = Math.max(0, Math.min(100, (weight / sendleMax) * 100));
        sendleEl.style.width = pct + "%";
      }
      if (ausEl && ausMax > 0) {
        const pct = Math.max(0, Math.min(100, (weight / ausMax) * 100));
        ausEl.style.width = pct + "%";
      }
    }

    const openPanel = () => {
      panel.hidden = false;
      panel.setAttribute("data-open", "true");
      if (scrim) { scrim.hidden = false; scrim.setAttribute("data-open", "true"); }
      fab.setAttribute("aria-expanded", "true");
      close?.focus();

      // 1) nudge theme scripts that recalc on resize
      setTimeout(() => window.dispatchEvent(new Event("resize")), 0);

      // 2) call your widget's refresh if it exists
      if (typeof window.cpUpdateProgress === "function") {
        try { window.cpUpdateProgress(); } catch (e) {}
      }

      // 3) hard fallback: force the widths from DOM values
      // do it twice in case values update after Ajax/cart change
      setTimeout(forceProgress, 0);
      setTimeout(forceProgress, 250);
    };

    const closePanel = () => {
      panel.removeAttribute("data-open");
      fab.setAttribute("aria-expanded", "false");
      if (scrim) scrim.removeAttribute("data-open");
      setTimeout(() => { panel.hidden = true; if (scrim) scrim.hidden = true; }, 180);
    };

    fab.addEventListener("click", () => {
      const isOpen = panel.getAttribute("data-open") === "true";
      isOpen ? closePanel() : openPanel();
    });
    close?.addEventListener("click", closePanel);
    scrim?.addEventListener("click", closePanel);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closePanel(); });
  });
})();
